export interface Story {
    Source: string | null;
    ContentTags: string[];
    NodeAlias: string;
    ByLine: string;
    Summary: string;
    Title: string;
    Text: string;
    ImageLink: string | null;
    ThumbnailImageLink: string | null;
    nextStoryUrl: string | null;
    prevStoryUrl: string | null;
    Id: number;
    Guid: string;
    ClassName: string | null;
    VideoLinks: Record<string, unknown>[] | null;
    CreatedWhen: string;
    ModifiedWhen: string;
    PublishWhen: string;
    Url: string | null;
    CreatedDate: string;
    ModifiedDate: string;
    PublishDate: string;
    ImageCaption: string | null;
    Location?: Record<string, unknown> | null; 
    ModifiedDateTimeUtc?: string;
}

export interface PrevNextDetails {
    storyId?: number;
    storyUrl?: string | null;
    storyTitle?: string | null;
    storyImageUrl?: string | null;
    storyVideoUrl?: Record<string, unknown>[] | null;
}

export interface PopupStoryResult {
    Story: Story;
    Id: number;
    Type: string;
    ShareText: string | null;
    ShareEmailSubject: string | null;
}

export enum NewsStoryPopupSourceRoutes {
    LifePollenPage = 'life.pollen',
    LifeColdFluPage = 'life.cold-flu',
    LifeOutdoorSportsPage = 'life.outdoor-sports',
    NewsPage = 'news',
    AllAlerts = 'alerts',
    SparkAlerts = 'alerts.spark',
    WeatherAlerts = 'alerts.weather',
    HurricaneAlerts = 'alerts.hurricane',
    PollenAlerts = 'alerts.pollen',
    AirQualityAlerts = 'alerts.airquality',
    SeverStormRisksAlerts = 'alerts.severestormrisk',
    FireAlerts = 'alerts.fire',
    AirQualityPage = 'air-quality',
    HurricanePage = 'hurricane'
}
